import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo.png?format=webp&w=200";
import logoFallback from "@/assets/logo.png?format=png&w=200";

const footerLinks = {
  services: [
    { name: "Monthly Bookkeeping", path: "/monthly-bookkeeping-services" },
    { name: "Payroll (EMP201 / EMP501)", path: "/payroll-emp201-emp501" },
    { name: "Annual Tax Returns", path: "/annual-tax-returns" },
    { name: "CIPC Annual Returns", path: "/cipc-annual-returns" },
    { name: "International Services", path: "/international-services" },
  ],
  guides: [
    { name: "Bookkeeping Guide", path: "/bookkeeping" },
    { name: "VAT in South Africa", path: "/vat" },
    { name: "CIPC Compliance", path: "/cipc" },
    { name: "Knowledge Centre", path: "/blog" },
    { name: "Free Tools", path: "/tools" },
  ],
  locations: [
    { name: "Cape Town", path: "/areas/cape-town" },
    { name: "Johannesburg", path: "/areas/johannesburg" },
    { name: "Durban", path: "/areas/durban" },
    { name: "All Areas We Serve", path: "/areas" },
  ],
  company: [
    { name: "About Us", path: "/about" },
    { name: "Packages & Pricing", path: "/packages" },
    { name: "Book a Call", path: "/book-a-call" },
    { name: "Contact", path: "/contact" },
    { name: "Privacy Policy", path: "/privacy" },
    { name: "Terms of Service", path: "/terms" },
  ],
};

export function Footer() {
  return (

    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <picture>
                <source srcSet={logo} type="image/webp" />
                <img
                  src={logoFallback}
                  alt="Bookkeeping Services SA"
                  className="h-12 w-auto brightness-0 invert"
                  width={48}
                  height={48}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </Link>
            <p className="text-background/70 text-sm leading-relaxed">
              Professional bookkeeping and accounting services built on trust. Serving South African businesses.
            </p>
            <div className="space-y-3 text-sm">
              <a href="mailto:info@bookkeepingservices.co.za" className="flex items-center gap-3 text-background/70 hover:text-background transition-colors">
                <Mail className="w-4 h-4" />
                info@bookkeepingservices.co.za
              </a>
              <div className="flex items-center gap-3 text-background/70">
                <MapPin className="w-4 h-4" />
                Remote across South Africa
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas We Serve */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Areas We Serve</h3>
            <ul className="space-y-3">
              {footerLinks.locations.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides & Resources */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Guides & Resources</h3>
            <ul className="space-y-3">
              {footerLinks.guides.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background/50">
            © {new Date().getFullYear()} Bookkeeping Services South Africa. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-background/60">Built on Trust</p>
          </div>

        </div>
      </div>
    </footer>
  );
}
